import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../../commonComponent/ComingSoon';

function Pos() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className=" p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">Point Of Sale</h1>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/dashboard/core-modules/pos/restaurant-bar-billing')}
              className="btn"
            >
              Restaurant & Bar Billing
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/pos/retail-pos')}
              className="btn text-black font-bold"
            >
              Retail Point of Sale
            </button>
          </div>
        </header>
        <ComingSoon />
      </div>
    </div>
  );
}

export default Pos;
